<div
  class="vc-body3 productInstallment"
  [class.productInstallment--link]="isClickable"
  *ngIf="isInstallmentPossible"
  (click)="openPaymentInstallmentInfo($event)"
>
  {{ textInstallment }}
  <img
    [ngClass]="'svg svg_' + mnemonic"
    [src]="'/assets/svg/carts/' + mnemonic + '.svg'"
    [alt]="product.installment?.name"
  />
</div>
